import { useContext } from 'react';

import { useLocation } from 'react-router-dom';

import { RouterContext } from './router.provider';

const useRouter = () => {
  const context = useContext(RouterContext);
  if (context === undefined) {
    throw new Error('useRouter must be used within a Router Provider!');
  }

  const { useNavigate, basePath, useLocation: useLocationContext } = context;

  return { useNavigate, basePath, useLocation: useLocationContext ?? useLocation };
};

export { useRouter };
